export const DEFAULT_STALE_TIME = 5 * 60000;

export const KEY_CURRENT_SHIPMENT_SIMPLE_DOMESTIC_FLOW =
  'KEY_CURRENT_SHIPMENT_SIMPLE_DOMESTIC_FLOW';
